import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgAward = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M16.953 3.125h-1.797v-.781A.157.157 0 0015 2.188H5a.157.157 0 00-.156.156v.781H3.047a.86.86 0 00-.86.86v2.89a3.208 3.208 0 002.7 3.164 5.006 5.006 0 004.41 4.307V16.4H5.469a.624.624 0 00-.625.625v.631c0 .086.07.157.156.157h10c.086 0 .156-.07.156-.157v-.63a.624.624 0 00-.625-.626h-3.828v-2.054a5.006 5.006 0 004.41-4.307 3.208 3.208 0 002.7-3.164v-2.89a.86.86 0 00-.86-.86zm-13.36 3.75V4.531h1.25v4.055a1.797 1.797 0 01-1.25-1.711zm10.157 2.5c0 .959-.373 1.863-1.053 2.541a3.57 3.57 0 01-2.54 1.053h-.313a3.566 3.566 0 01-2.541-1.053A3.57 3.57 0 016.25 9.375V3.594h7.5v5.781zm2.656-2.5c0 .8-.525 1.48-1.25 1.71V4.532h1.25v2.344z" />
    </Icon>
  );
};

export default SvgAward;
